
import { mixins, Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import store from './store';
import SpinnerContainer from '@/components/spinnerContainer/spinnerContainer.vue';
import { LocalizedClient, StepConfigClient, TavolaClient } from './services/Services';
import { ModalServices } from './services/ModalServices';
import * as OM from '@/Model';
import { StorageServices } from './services/StorageServices';

@Options({
    components: {
        SpinnerContainer
    },
})
export default class App extends Vue {

    loaded: boolean = false;

    created(){
        ModalServices.setOpModal(this.$opModal);
        window.addEventListener('scroll', (ev) => {
            store.state.scrollCb(ev);
        });

        Promise.all([
            LocalizedClient.getAll(),
            LocalizedClient.getEnabledLanguages(),
            StepConfigClient.getStepConfigs()
        ])
        .then( x => {
            store.state.consts.localizedValues = x[0];
            store.state.consts.enabledLanguages = x[1];
            store.state.stepConfigs = x[2];
            if(!store.state.selectedLanguage){
                store.state.selectedLanguage = store.state.consts.enabledLanguages[0];
                StorageServices.SetLanguage(store.state.selectedLanguage);
            }
        }).finally( () => {
            setTimeout(() => {
                if(this.$route.query.lang){
                    if(this.$route.query.lang == 'it'){
                        store.state.selectedLanguage = "it-IT";
                        StorageServices.SetLanguage(store.state.selectedLanguage);
                    } else if(this.$route.query.lang == 'en'){
                        store.state.selectedLanguage = "en-US";
                        StorageServices.SetLanguage(store.state.selectedLanguage);
                    }
                }
                if(this.$route.query.tid){
                    TavolaClient.getById(<string>this.$route.query.tid)
                    .then(x => {
                        store.state.tavola = x;
                        // setTimeout(() => {
                        //     this.$router.push('/table/step0')
                        // }, 10)
                        // setTimeout(() => {
                        //     this.$router.push('/table/step2')
                        // }, 20)
                        // setTimeout(() => {
                            this.$router.push('/table/riepilogo');
                        // }, 30)
                    })
                    .finally(() => this.loaded = true);
                } else {
                    this.loaded = true;
                }
            }, 100);
        })
    }

    @Watch("$store.state.showSpinner")
    disableScroll(next, prev){
        var el = document.getElementById("body");
        
        if(el == null)
          return;
        
        if(next > 0)
            el.classList.add("overflow-hidden");
        else
            el.classList.remove("overflow-hidden");
    }

}
